import React, { ReactNode } from "react";

const Product = ({
  children,
  isNew,
  isMixed,
  isDishWashedShape,
  isComingSoon,
}: {
  children: ReactNode;
  isNew?: boolean;
  isMixed?: boolean;
  isDishWashedShape?: boolean;
  isComingSoon?: boolean;
}) => {
  return (
    <div
      className="rounded-xl relative py-2 z-20 dark:bg-gray-800 dark:border-gray-700"
      style={{
        // boxShadow: "0px 5px 30px rgba(0, 0, 0, 0.05)",
        // opacity: 0.9,
        // backgroundColor: 'rgba(255, 255, 255, 0.8)',
        height: '100%',
        backgroundColor: '#ffff',
        width: '100%',
        marginBottom: '20px',
      }}
    >
      {isNew && (
        <div className="absolute -top-3 -right-3 md:-top-4 md:-right-4 bg-[#E56C5C] w-16 h-16 md:w-[60px] md:h-[60px] lg:w-[70px] lg:h-[70px] rounded-full flex items-center justify-center text-center p-1">
          <span className="uppercase text-white font-bold text-xs md:text-[11px] lg:text-[12px] leading-none text-center">
            New
          </span>
        </div>
      )}
      {isMixed && (
        <div className="absolute -top-3 -right-3 md:-top-4 md:-right-4 bg-[#F9C645] w-16 h-16 md:w-[60px] md:h-[60px] lg:w-[70px] lg:h-[70px] rounded-full flex items-center justify-center text-center p-1">
          <span className="uppercase text-white font-bold text-[9px] md:text-[9px] lg:text-[10px] leading-[1.1] text-center">
            Mix &<br />Match!
          </span>
        </div>
      )}
      {isDishWashedShape && (
        <div className="absolute -top-3 -right-3 md:-top-4 md:-right-4 bg-[#75A7AD] w-16 h-16 md:w-[60px] md:h-[60px] lg:w-[70px] lg:h-[70px] rounded-full flex items-center justify-center text-center p-1">
          <span className="uppercase text-white font-bold text-[8px] md:text-[7px] lg:text-[8px] leading-[1.1] text-center">
            Dish-<br />washer<br />Safe
          </span>
        </div>
      )}
      {isComingSoon && (
        <div className="absolute -top-3 -right-3 md:-top-4 md:-right-4 bg-[#E56C5C] w-16 h-16 md:w-[60px] md:h-[60px] lg:w-[70px] lg:h-[70px] rounded-full flex items-center justify-center text-center p-1">
          <span className="uppercase text-white font-bold text-[9px] md:text-[9px] lg:text-[10px] leading-[1.1] text-center">
            {/* Coming<br />Soon */}
            New
          </span>
        </div>
      )}
      {children}
    </div>
  );
};

export default Product;